import { useQuery } from '@tanstack/vue-query';
import { isAxiosError } from 'axios';
import { ref, Ref } from 'vue';

import contractFormalization
  from '~/services/contract-formalization-api/contract-formalization-api';
import { queryKeys } from '~/store/queryClient';

export default function useFormalizationInfo(projectId: Ref<string>) {
  const queryKey = ref(queryKeys.CONTRACT_FORMALIZATION.INFO(projectId.value));

  const queryFn = () => contractFormalization.getFormalizationInfo(projectId.value);

  const query = useQuery({
    queryFn,
    queryKey,
    retry: (failureCount, error) => {
      if (isAxiosError(error) && error.response?.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
  });

  return query;
}

// eslint-disable-next-line perfectionist/sort-modules
export type UseFormalizationInfoData = Awaited<ReturnType<typeof useFormalizationInfo>>['data']['value'];
